import { useState } from 'react';
import './style.common.scss';
// import { Table } from '@intellicar/phoenix-design-system';
import Table from 'app/shared/Table';
import moment from 'moment';
import { getSOCBasedColor } from 'utils/HelperFunctions';
import { JSONTOCSV } from 'utils/HelperFunctions';
import { getUserInfo } from 'utils/auth';
import { ReactComponent as ExpandIcon } from 'assets/icons/expand.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import SearchBox from 'app/shared/SearchBox';
import EmptyState from 'app/shared/EmptyState';
function CurrentlyCharging(props) {
	const [activeTab, setActiveTab] = useState(0);
	const [openModal, setOpenModal] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');

	// useEffect(() => {
	// 	getLastUpdated();
	// 	// eslint-disable-next-line
	// }, []);
	const getCSVName = () => {
		let auth = getUserInfo();
		let date = moment().format('DD-MM-YYYY_h:mmA');
		return auth.username + '_Currently_Charging_' + date;
	};

	// const getLastUpdated = () => {
	// 	let data = props.data.history;
	// 	if(data.length>0){
	// 		let last = Math.max.apply(
	// 			Math,
	// 			data.map(function (charge) {
	// 				return charge.starttime;
	// 			})
	// 		);
	// 		// let findLast = last + 1800000 - ((last + 1800000) % 1800000);
	// 		let findLast = last;
	// 		setUpdatedAt(findLast ? moment(findLast).format('DD MMM YYYY, h:mm A') : 'Not available');
	// 	}
	// };
	const processTableHeader = () => {
		let processed = [];
		for (let idx in props.heads) {
			let obj = {
				title: props.heads[idx].heading,
				key: props.heads[idx].key,
				sortable: true,
				dataIndex: props.heads[idx].key,
			};

			if (props.heads[idx].key === 'starttime') {
				obj.align = 'center';
				obj.render = (text) => {
					return (
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<span>{moment(text).format('D MMM YYYY ')}</span>
							<span style={{ marginBottom: 2 }}>{moment(text).format('h:mm A')}</span>
						</div>
					);
				};
			}
			if (props.heads[idx].key === 'startsoc') {
				obj.align = 'right';
			}
			if (props.heads[idx].key === 'soc') {
				obj.align = 'center';
				obj.render = (text) => {
					return (
						<div
							style={{
								borderRadius: 30,
								padding: 2,
								textAlign: 'center',
								background: getSOCBasedColor(text),
								width: '4rem',
								margin: 'auto',
							}}
						>
							{text}
							{props.heads[idx].unit}
						</div>
					);
				};
			}
			processed.push(obj);
		}
		return processed;
	};
	const processTableData = (source) => {
		if (source === 'table') {
			return props.data.history.map((item, idx) => ({
				...item,
				key: idx,
				soc: Number(item.soc).toFixed(2),
			}));
		} else {
			return props.data.history.map((item, idx) => ({
				...item,
				key: idx,
				soc: Number(item.soc).toFixed(2),
				starttime: moment(item.starttime).format('D MMM YYYY h:mm A'),
			}));
		}
	};

	const searchTable = (key) => {
		// if (key.length < 3) return;
		setSearchQuery(key);
	};

	const renderView = () => {
		return activeTab === 0 ? (
			<div className="NumStats">
				<i className="fas fa-plug" style={{ marginRight: 10 }}></i>
				{props.data.distribution}
			</div>
		) : (
			<div className="tableView">
				<Table
					columns={processTableHeader()}
					dataSource={processTableData('table')}
					onSearch={searchTable}
					searchQuery={searchQuery}
					searchKey={'vehno'}
					striped
					slim
					modal={openModal}
				/>
			</div>
		);
	};

	const renderWidgetTab = () => {
		return (
			<div
				className="WidgetControl"
				style={{ justifyContent: activeTab === 1 ? 'space-between' : 'flex-end' }}
			>
				{activeTab === 1 ? (
					<div className="SearchControl">
						<SearchBox placeholder={'Search'} onSearch={searchTable} rounded />
					</div>
				) : null}
				<div className="WidgetTab">
					<ul>
						<li onClick={() => setActiveTab(0)} className={activeTab === 0 ? 'active' : ''}>
							Chart
						</li>
						<li onClick={() => setActiveTab(1)} className={activeTab === 1 ? 'active' : ''}>
							Table
						</li>
					</ul>
				</div>
			</div>
		);
	};
	return (
		<div className="WidgetContainer">
			<div className="WidgetHeader">
				<div className="Title">Currently Charging</div>
				{/* {updatedAt &&<div style={{ fontSize: 10 }}>* Last updated at {updatedAt}</div>} */}
				{props.isLive ? (
					<div className="RightControl">
						<DownloadIcon
							onClick={() =>
								JSONTOCSV(processTableData('download'), processTableHeader(), getCSVName())
							}
							style={{ marginRight: 14, cursor: 'pointer' }}
						/>
						<ExpandIcon style={{ cursor: 'pointer' }} onClick={() => setOpenModal(true)} />
					</div>
				) : null}
			</div>
			<div className="WidgetContent">
				{props.isLive ? (
					<>
						{renderWidgetTab()}
						<div className="ContentContainer">{renderView()}</div>
					</>
				) : (
					<EmptyState
						size="xs"
						title=""
						description="This data is applicable only for today's date"
					/>
				)}
			</div>
			<div className="Modal" style={{ display: openModal ? 'block' : 'none' }}>
				<div className="ModalContent">
					<div className="ModalHeader">
						<span onClick={() => setOpenModal(false)} className="close">
							&times;
						</span>
					</div>
					<span
						className="mh-download"
						style={{ position: 'relative', top: '0.5rem', float: 'right' }}
					>
						<DownloadIcon
							onClick={() =>
								JSONTOCSV(processTableData('download'), processTableHeader(), getCSVName())
							}
							style={{ marginRight: 14, cursor: 'pointer' }}
						/>
					</span>
					<div
						className="Title"
						style={{ fontWeight: 500, position: 'relative', top: '5px', width: '500px' }}
					>
						Currently Charging
					</div>
					<div className="ModalContainer">
						{renderWidgetTab()}

						<div className="WidgetView">{renderView()}</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default CurrentlyCharging;
